import { api } from '../../api/api';
import {
  CHANGEREQ_REQUEST, GET_CHANGEREQS_SUCCESS,
  ADD_CHANGEREQ_SUCCESS, UPDATE_CHANGEREQ_SUCCESS,
} from '../constant';

export const getChangeRequests = (userId, opts = {}) => async (dispatch) => {
  dispatch({ type: CHANGEREQ_REQUEST });
  try {
    const params = new URLSearchParams();
    if (opts.subuserId) params.set('subuserId', opts.subuserId);
    if (opts.storeIds && opts.storeIds.length) params.set('storeIds', opts.storeIds.join(','));
    const q = params.toString();
    const url = q ? `/changerequest/getall/${userId}?${q}` : `/changerequest/getall/${userId}`;
    const res = await api.get(url);
    dispatch({ type: GET_CHANGEREQS_SUCCESS, payload: res.data.requests });
  } catch (e) {}
};

export const addChangeRequest = (data) => async (dispatch) => {
  try {
    const res = await api.post('/changerequest/add', data);
    if (res.status === 201) dispatch({ type: ADD_CHANGEREQ_SUCCESS, payload: res.data.changeRequest });
    return res.data.changeRequest;
  } catch (e) {}
};

export const updateChangeRequest = (id, data) => async (dispatch) => {
  try {
    const res = await api.patch(`/changerequest/update/${id}`, data);
    if (res.status === 200) dispatch({ type: UPDATE_CHANGEREQ_SUCCESS, payload: res.data.changeRequest });
  } catch (e) {}
};
